// prettier-ignore
export const fallbackImg ="data:image/png;base64,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"

export const appTheme = {
  token: {
    fontFamily: "Cairo, sans-serif",
    colorPrimary: "#00086D",
    colorInfo: "#faad14",
    borderRadius: 8,
    colorText: "#020418",
    fontSize: 16,
    controlHeight: 42,
    colorBtnColor: "#fff",
    secBtnBg: "#F8F5FF",
    secColor: "#8A4CF5",
    defaultBg: "#EEF0FF",
    defaultColor: "#4F5062",
    defaultBorderColor: "#B0B0C0",
    thirdColor: "#59A6ED",
    contentFontSize: 16,
    Accent: "#EBF2FA",
    line: "#CFD8E3",
    grayTxt: "#595959",
    linearBg: "linear-gradient(270deg, #8A4CF5 0%, #595FBC 100%)",
    secBtnBorderColor: "#C7BBF9",
    colorPrimaryBgHover: "#595FBC",
    colorTextPlaceholder : "#75757E",
    colorPrimaryHover: "#595FBC",
    colorTextDescription: "#00086D",
    colorPrimaryActive: "#595FBC",
    colorPrimaryText: "#FFF",
    colorPrimaryTextActive: "#FFF",
    colorPrimaryTextHover: "#fff",
    colorLink: "#00086D",
    colorLinkHover: "#00086D",
    colorSuccess: "#238709",
    colorSuccessBg: "#E9FFDA",
    colorWarning: "#ff9d00",
    colorWarningBg: "#FFF4E2",
    colorError: "#cf2110",
    colorErrorBg: "#FFE7E4",
    colorTextBase: "#000",
    colorFillQuaternary: "#ebf2fa",
    colorFillSecondary: "#ebf2fa",
    colorPrimaryBg: "#ede8ff",
    fontSizeXL: 18,
    fontSizeHeading5: 16,
    fontSizeHeading4: 18,
    fontSizeHeading3: 22,
    fontSizeHeading2: 25,
    fontSizeHeading1: 32,
    marginMD: 24,
    wireframe: false,
    marginLG: 32,
    marginXL: 40,
    paddingMD: 24,
    paddingLG: 32,
    paddingXL: 40,
    borderRadiusSM: 4,
    borderRadiusLG: 12,
    borderRadiusXS: 4,
    colorBgLayout: "#F0F1F2",
    colorBgContainer: "#ffffff",
    colorBgElevated: "#ffffff",
    boxShadow: "0px 0px 24px rgba(0, 0, 0, 0.1);",
    boxShadowSecondary: "0px 0px 24px rgba(0, 0, 0, 0.1);",
    colorPrimaryBorder: "#00086D",
  },
  // Button : {
  //   defaultColor: "#FFF",
  // },
  components: {
    Radio: {
      colorPrimary: "#00086D",
    },
    Checkbox: {
      borderRadius: 4,
    },
    Select: {},
    Form: {
      // size: 'large',
      size: 50,
    },
  },
}

export const appThemeEn = {
  token: {
    fontFamily: 'Inter, sans-serif',
    colorPrimary: '#00086D',
    colorInfo: '#faad14',
    borderRadius: 8,
    colorText: '#020418',
    fontSize: 16,
    controlHeight: 42,
    colorBtnColor: '#fff',
    secBtnBg: '#F8F5FF',
    secColor: '#8A4CF5',
    defaultBg: '#EEF0FF',
    defaultColor: '#4F5062',
    defaultBorderColor: '#B0B0C0',
    thirdColor: '#59A6ED',
    contentFontSize: 16,
    Accent: '#EBF2FA',
    line: '#CFD8E3',
    grayTxt: '#595959',
    linearBg: 'linear-gradient(270deg, #8A4CF5 0%, #595FBC 100%)',
    secBtnBorderColor: '#C7BBF9',
    colorPrimaryBgHover: '#595FBC',
    colorTextPlaceholder: '#75757E',
    colorPrimaryHover: '#595FBC',
    colorTextDescription: '#00086D',
    colorPrimaryActive: '#595FBC',
    colorPrimaryText: '#FFF',
    colorPrimaryTextActive: '#FFF',
    colorPrimaryTextHover: '#fff',
    colorLink: '#00086D',
    colorLinkHover: '#00086D',
    colorSuccess: '#238709',
    colorSuccessBg: '#E9FFDA',
    colorWarning: '#ff9d00',
    colorWarningBg: '#FFF4E2',
    colorError: '#cf2110',
    colorErrorBg: '#FFE7E4',
    colorTextBase: '#000',
    colorFillQuaternary: '#ebf2fa',
    colorFillSecondary: '#ebf2fa',
    colorPrimaryBg: '#ede8ff',
    fontSizeXL: 18,
    fontSizeHeading5: 16,
    fontSizeHeading4: 18,
    fontSizeHeading3: 22,
    fontSizeHeading2: 25,
    fontSizeHeading1: 32,
    marginMD: 24,
    wireframe: false,
    marginLG: 32,
    marginXL: 40,
    paddingMD: 24,
    paddingLG: 32,
    paddingXL: 40,
    borderRadiusSM: 4,
    borderRadiusLG: 12,
    borderRadiusXS: 4,
    colorBgLayout: '#F0F1F2',
    colorBgContainer: '#ffffff',
    colorBgElevated: '#ffffff',
    boxShadow: '0px 0px 24px rgba(0, 0, 0, 0.1);',
    boxShadowSecondary: '0px 0px 24px rgba(0, 0, 0, 0.1);',
    colorPrimaryBorder: '#00086D',
  },
  // Button : {
  //   defaultColor: "#FFF",
  // },
  components: {
    Radio: {
      colorPrimary: '#00086D',
    },
    Checkbox: {
      borderRadius: 4,
    },
    Select: {},
    Form: {
      // size: 'large',
      size: 50,
    },
  },
};

const constents = {
  gutterResponsive: [
    { xs: 8, sm: 16, md: 24, lg: 30 },
    { xs: 8, sm: 16, md: 24, lg: 30 },
  ],
  dateFormat: "YYYY-MM-DD",
  dateFormatHM: "YYYY-MM-DD HH:MM A",
  rulesRequeried: [
    {
      required: true,
    },
  ],
 
};

export const servicesEnum = {
  0: "products",
  1: "services",
  2: "gift_cards",
  3: "memberships",
}
export default constents;
